import { render, staticRenderFns } from "./SelectPropertiesAndBuildings.vue?vue&type=template&id=a06883e8&scoped=true"
import script from "./SelectPropertiesAndBuildings.vue?vue&type=script&lang=js"
export * from "./SelectPropertiesAndBuildings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06883e8",
  null
  
)

export default component.exports